<template>
  <div class="px-4 sm:px-0">
    <div class="block">
      <div class="flex border-b border-gray-200 justify-between">
        <nav class="mt-2 -mb-px flex space-x-8" aria-label="Tabs">
          <a v-for="tab in filteredTabs" :key="tab.name"
             :class="[tab.index === currentIndex ? 'border-yellow-500 text-yellow-600' :
             'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200',
             'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm cursor-pointer']"
             v-on:click="handleTabSelected(tab)"
          >
            {{ tab.name }}
            <span v-if="tab.count"
                  :class="[tab.index === currentIndex ? 'bg-yellow-100 text-yellow-600' :
                  'bg-gray-300 text-gray-900',
                  'ml-2 py-0.5 px-2.5 rounded-full text-xs font-medium inline-block']">{{
                tab.count
              }}</span>
          </a>
        </nav>
        <div class="relative z-0 max-w-xs flex-1 px-2 flex items-center justify-center">
          <div class="pointer-events-none absolute inset-y-0 left-2 pl-3 flex items-center">
            <SearchIcon class="h-5 w-5 text-gray-400" aria-hidden="true"/>
          </div>
          <input id="search"
                 name="search"
                 @input="debounce($event.target.value)"
                 class="block w-full bg-white border border-gray-300 rounded-md py-2 pl-10 pr-3 text-sm
                 placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400
                 focus:ring-1 focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm"
                 placeholder="Search actions"
                 type="search"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {SearchIcon} from '@heroicons/vue/solid'

export default {
  name: "TabSelector",
  components: {
    SearchIcon
  },
  emits: ['searchText'],
  props: {
    tabs: Object,
    currentIndex: Number,
  },
  setup(props, {emit}) {
    console.log(props.currentIndex);
    const handleTabSelected = (tab) => {
      emit("tabSelected", tab);
    };

    function createDebounce() {
      let timeout = null;
      return function (text) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          emit('searchText', text);
        }, 800);
      };
    }

    const filteredTabs = props.tabs.filter(tab => tab.isEnabled);

    return {
      debounce: createDebounce(),
      handleTabSelected,
      filteredTabs
    }
  }
}

</script>